// this file is for validation of billing and shipping for  checkout component 
import * as yup from 'yup';

export const BillingAddressSchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Must be a valid email').required('Email is required'),
  phone: yup.string().matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits').required('Phone number is required'),
  pan: yup.string().matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'PAN must be valid').required('PAN is required'),
  dob: yup.date().required('Date of birth is required'),
  address: yup.string().required('Address is required'),
  state: yup.string().required('State is required'),
  city: yup.string().required('City is required'),
  landmark: yup.string().required('Landmark is required'),
  zip: yup.string().matches(/^[0-9]{6}$/, 'ZIP code must be exactly 6 digits').required('ZIP code is required')
});

export const ShippingAddressSchema = yup.object().shape({
  address: yup.string().required('Address is required'),
  state: yup.string().required('State is required'),
  city: yup.string().required('City is required'),
  landmark: yup.string().required('Landmark is required'),
  zip: yup.string().matches(/^[0-9]{6}$/, 'ZIP code must be exactly 6 digits').required('ZIP code is required')
});
